<template>
  <div class="global-search-list overflow-auto" :style="{ maxHeight }">
    <GlobalSearchResultRow
      v-for="(result, index) in results"
      :key="`${result.type}:${result.id}`"
      :result="result"
      :selected="index === selectedIndex"
      @click="$emit('selected', result)"
    />
  </div>
</template>

<script setup lang="ts">
import type { GlobalSearchResult } from "../helper/GlobalSearchNavigation";
import GlobalSearchResultRow from "./GlobalSearchResultRow.vue";

withDefaults(
  defineProps<{
    results: GlobalSearchResult[];
    selectedIndex?: number;
    maxHeight?: string;
  }>(),
  {
    selectedIndex: -1,
    maxHeight: "60vh",
  },
);

defineEmits<{
  selected: [result: GlobalSearchResult];
}>();
</script>

<style scoped lang="scss">
.global-search-list {
  min-height: 0;
}
</style>
